module.exports = __webpack_public_path__ + "img/brain.4b04012b.png";